import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(5),
    background: theme.palette.background.calculator,
    backdropFilter: 'blur(60px)',
    textAlign: 'start',
    maxWidth: '380px',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  iconListTitle: {
    fontSize: '1.5rem',
    marginBottom: theme.spacing(4),
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    '&>div': {
      lineHeight: 1,
      '&>p': {
        marginBottom: 0,
      },
    },
  },
  SVGIcon: {
    display: 'inline-block',
    marginInlineEnd: theme.spacing(1),
    '& svg': {
      fill: theme.palette.secondary.main,
    },
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  footerText: {
    marginTop: theme.spacing(3),
    fontSize: '1rem',
    color: theme.palette.text.lightGrey,
  },
}))
